<script>
export default {
  name: 'field-upload',
  props: {
    accept: {
      type: String,
      required: true
    }
  }
}
</script>
<template lang="pug">
.upload-wrapper
    v-btn(
      class="upload-text"
      color="primary"
      block
    )
      v-icon cloud_upload
      slot
    input(type="file" @change="$emit('change-file', $event)" :accept="accept")
</template>
<style lang="stylus" >
.upload-wrapper
  position relative
  overflow hidden
.upload-wrapper
  input[type=file]
    font-size 100px
    position absolute
    left 0
    top 0
    opacity 0
</style>
